var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.statusMap[_vm.status])?_c('div',{staticClass:"kyc-tag"},[_c('sb-badge',{attrs:{"variation":_vm.statusMap[_vm.status].type,"size":"extra-small"}},[_vm._v("\n    "+_vm._s(_vm.statusMap[_vm.status].title)+"\n  ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }